export default __webpack_public_path__ + "static/media/1 Mueble aglomerado archivador.383156fa.jpeg";